export const pluralize = (toPluralize: string, count: number, suffix = 's') => {
  const pr = new Intl.PluralRules('en')
  return `${toPluralize}${pr.select(count) === 'one' ? '' : suffix}`
}
